<template>
  <div>
    <!-- START SEARCH BAR -->
    <div class="form-search">
      <div class="row-fluid">
        <div class="span2">
          <datepicker :value="date" @input="(val) => (date = val)" id="date_somministration" />
        </div>
        <div v-if="strutturaResidenziale" class="span4">
          <div v-if="!isMobile" class="span4">{{ i18nJS.order_by_label }}</div>
          <div class="span4 btn-group" id="tab">
            <div :class="['btn', 'btn-small', { active: sort !== 'roombed' }]" @click="sort = 'anagraphic'">
              <fa-icon :icon-name="'fa-user'" :no-theme="true" />
              <span v-if="!isMobile"> {{ i18nJS.fullname }}</span>
            </div>
            <div :class="['btn', 'btn-small', { active: sort === 'roombed' }]" @click="sort = 'roombed'">
              <fa-icon :icon-name="'fa-bed'" :no-theme="true" />
              <span v-if="!isMobile"> {{ i18nJS.roombed_label }}</span>
            </div>
          </div>
        </div>
        <div v-show="therapiesEmrEnabled" class="span3">
          <div id="tab2" class="btn-group">
            <div :class="['btn', 'btn-small', { active: !onlyEmergency }]" @click="onlyEmergency = false">
              <span class="fa-stack fa-xs">
                <fa-icon :icon-name="'fa-truck-medical'" :no-theme="true" class="fa-stack-1x" />
                <fa-icon :icon-name="'fa-ban'" :no-theme="true" class="fa-stack-2x" style="color: Tomato" />
              </span>
              <span v-if="!isMobile"> {{ i18nJS.not_in_emergency }}</span>
            </div>
            <div :class="['btn', 'btn-small', { active: onlyEmergency }]" @click="onlyEmergency = true">
              <fa-icon :icon-name="'fa-truck-medical'" :no-theme="true" />
              <span v-if="!isMobile"> {{ i18nJS.only_emergency }}</span>
            </div>
          </div>
        </div>
        <div class="mychzn pull-right span3">
          <label class="control-label">
            <v-select2
              :options-list="sommTypeList"
              data-placeholder="Via somministrazione"
              data-allow-clear="true"
              @input="(val) => (sommType = val)"
            />
          </label>
        </div>
      </div>
    </div>
    <!-- END SEARCH BAR -->
    <hr />
    <!-- START THERAPIES -->
    <component :is="showComponent" :guests="sortedGuest" :selected="guestSelected">
      <template slot-scope="guest">
        <guest-tab :guest="guest" :b-day-show="true" />
      </template>
      <guest-therapies
        slot="content"
        v-if="guestSelected"
        :allergies-url="allergiesUrl"
        :guest="guestSelected"
        :therapies.sync="guestTherapies"
        :bugiardino-link="bugiardinoLink"
        :time-id="timeId"
        :therapies-ab-constraints-enabled="therapiesAbConstraintsEnabled"
        :options-waste="optionsWaste"
        :confirmed-therapy-enabled="confirmedTherapyEnabled"
        :enable-waste-management="enableWasteManagement"
        :enable-massive-somministration="enableMassiveSomministration"
        :options-cause="optionsCause"
        :date="date"
        :time="time"
        :hours-limit="hoursLimit"
        :manage-therapy="manageTherapy"
        :minutes-before-limit="minutesBeforeLimit"
        :therapies-preparation-enabled="therapiesPreparationEnabled"
        :therapies-xp-enabled="therapiesXpEnabled"
        :can-print="canPrint"
        :url-to-diary="urlToDiary"
        :is-mobile="isMobile"
        :magazzino-and-scarico="magazzinoAndScarico"
        can-discharge-warehouse="canDischargeWarehouse"
        :principio-attivo="principioAttivo"
        :can-somministration="canSomministration"
      />
    </component>
    <!-- END THERAPIES -->
    <modal-bar-code-reader v-if="readBarCode" :time-id="timeId" :date="date" />
    <adv-popup-qr-code-reader :popup-opened="qrcodeReaderOpened" :key="qrcodeReaderKey" @qrCodeAquired="(res) => qrCodeAquired(res)" />
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import guestTab from '../guestTab';
import faIcon from '../faIcon';
import vSelect2 from '../vSelect2';
import datepicker from '../datepicker';
import collapseTherapies from './collapseTherapies';
import ModalBarCodeReader from './modalBarCodeReader';
import guestTherapies from './guestTherapies';
import tabTherapies from './tabTherapies';
import { advPopupQrCodeReader } from '§/components/popupQrCodeReader';
import { notificationMixin } from '§/mixin/commonMixins.js';

export default {
  name: 'drugsSomministrations',
  props: [
    'urlItems',
    'loadDate',
    'urlDrugsSomministrations',
    'strutturaResidenziale',
    'therapiesEmrEnabled',
    'sommTypeList',
    'urlTherapy',
    'bugiardinoLink',
    'therapiesAbConstraintsEnabled',
    'enableWasteManagement',
    'enableMassiveSomministration',
    'optionsWaste',
    'optionsCause',
    'time',
    'timeId',
    'hoursLimit',
    'minutesBeforeLimit',
    'manageTherapy',
    'therapiesPreparationEnabled',
    'therapiesXpEnabled',
    'defaultOrder',
    'canPrint',
    'urlToDiary',
    'principioAttivo',
    'canDischargeWarehouse',
    'magazzinoAndScarico',
    'canSomministration',
    'confirmedTherapyEnabled',
    'readBarCode',
    'qrCodeReaderEnabled',
  ],
  components: {
    ModalBarCodeReader,
    vSelect2,
    faIcon,
    guestTab,
    datepicker,
    guestTherapies,
    collapseTherapies,
    tabTherapies,
    advPopupQrCodeReader,
  },
  mixins: [notificationMixin],
  data() {
    return {
      epUrl: `${window.config.ePersonamService.ePersonamHost}/${window.locale}`,
      guests: [],
      sort: null,
      onlyEmergency: false,
      guestSelected: null,
      allergiesUrl: null,
      guestTherapies: {},
      sommType: null,
      isMobile: false,
      windowWidth: window.innerWidth,
      date: null,
      qrcodeReaderOpened: false,
      qrcodeReaderKey: 'qrcodeReaderKey',
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    showComponent() {
      return this.isMobile ? 'collapse-therapies' : 'tab-therapies';
    },
    sortedGuest() {
      if (this.guests) {
        const guestOrdered = [...this.guests];
        return guestOrdered.sort(this.compare);
      } else {
        return [];
      }
    },
  },
  watch: {
    windowWidth: {
      immediate: true,
      handler(val) {
        this.isMobile = val <= 1000;
      },
    },
    date: function value(val) {
      this.changeHrefReport('date', val);
      this.loadGuest();
    },
    onlyEmergency: function value(val) {
      this.changeHrefReport('only_emergency', val);
      this.loadGuest();
    },
    sommType: function value(val) {
      this.changeHrefReport('somm_type', val);
      this.loadGuest();
    },
    sort: {
      immediate: true,
      handler() {
        if (!this.qrCodeReaderEnabled) this.guestSelected = this.sortedGuest[0];
      },
    },
    guestSelected: function value(newVal) {
      Loader.show();
      this.guestTherapies = null;
      if (!newVal) return Loader.hide();
      this.allergiesPath(newVal.id);
      let newUrl = Utils.addGetParam(this.urlTherapy.replace('__GUEST_PERIOD_DATA_SET_ID__', newVal.id), 'date', this.date);
      newUrl = Utils.addGetParam(newUrl, 'somm_type', this.sommType);
      newUrl = Utils.addGetParam(newUrl, 'only_emergency', this.onlyEmergency);
      apiConnector()
        .get(newUrl)
        .then(({ data }) => {
          if (this.qrCodeReaderEnabled && data.length == 0) this.noGuestFoundError();
          this.guestTherapies = data;
          Loader.hide();
        });
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.date = this.loadDate;
    this.$on('guestSelected', (guest) => (this.guestSelected = guest));
    this.loadGuest();
    window.DatePKR.init();

    Loader.show();

    if (this.qrCodeReaderEnabled) {
      document.querySelector('#qr_code_reader_btn').addEventListener('click', this.onQrCodeReaderClick);
      Loader.hide();
    }
  },
  destroy() {
    window.removeEventListener('resize', this.onResize);
    document.querySelector('#qr_code_reader_btn').removeEventListener('click', this.onQrCodeReaderClick);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    onQrCodeReaderClick() {
      this.qrcodeReaderOpened = true;
      this.qrcodeReaderKey += 1;
    },
    allergiesPath(gpds_id) {
      this.allergiesUrl = this.epUrl + '/guest_period_data_sets/' + gpds_id + '/guest_allergies?guest_period_data_set_id=' + gpds_id;
    },
    changeHrefReport(paramName, val) {
      let url = $('#print-therapies').prop('href');
      url = Utils.addGetParam(url, paramName, val);
      $('#print-therapies').prop('href', url);
      const export_armadio = $('#export-armadio');
      if (export_armadio && paramName == 'date') {
        let url = export_armadio.prop('href');
        url = Utils.addGetParam(url, 'from', val);
        url = Utils.addGetParam(url, 'to', val);
        export_armadio.prop('href', url);
      }
    },
    loadGuest() {
      let newUrl = Utils.addGetParam(this.urlItems, 'date', this.date);
      newUrl = Utils.addGetParam(newUrl, 'somm_type', this.sommType);
      newUrl = Utils.addGetParam(newUrl, 'only_emergency', this.onlyEmergency);
      apiConnector()
        .get(newUrl)
        .then(({ data }) => {
          this.guests = data;
          if (this.guests.length === 0) {
            Loader.hide();
          }
          if (!this.sort) {
            this.sort = this.defaultOrder;
          } else {
            if (!this.qrCodeReaderEnabled) this.guestSelected = this.sortedGuest[0];
          }
          window.Utils.pushState(window.Utils.addGetParam(window.location.href, 'date', this.date));
        })
        .catch((err) => {
          console.log('Could not set initial value', err);
        });
    },
    showTherapies(guest) {
      this.guestSelected = guest;
    },
    compare(a, b) {
      if (this.sort === 'roombed') {
        if (a.room_bed_label < b.room_bed_label) return -1;
        if (a.room_bed_label > b.room_bed_label) return 1;
        return 0;
      } else {
        if (a.full_name < b.full_name) return -1;
        if (a.full_name > b.full_name) return 1;
        return 0;
      }
    },
    qrCodeAquired(res) {
      let gpds_id = parseInt(res.data);

      if (!this.checkGpds(gpds_id)) {
        this.guestSelected = null;
        return this.noGuestFoundError();
      }

      if (this.isMobile) {
        const el = document.querySelector(`a[href="#collapseGuestTherapy${res.data}"]`);

        if (el) {
          el.click();
        }
      } else {
        this.guestSelected = { id: gpds_id };
      }
    },
    noGuestFoundError() {
      const params = {
        timeout: 10000,
        message: { error: 'Nessun utente trovato' },
        response: { error: { message: '' } },
      };
      this.NF_toast(params);
    },
    checkGpds(gpds_id) {
      return this.guests.some((item) => item.id === gpds_id);
    },
  },
};
</script>
